module.exports = __webpack_public_path__ + "static/img/banner_财务共享中心的AI风控审核方案.37c21cc0.png";